import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6553ec46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "span-title" }, "Total")
], -1))
const _hoisted_3 = { class: "content-box" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "prix" }, "20.00 $", -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "prix" }, "0.00 $", -1))
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "prix" }, "0,00 $", -1))
const _hoisted_10 = { class: "footer-box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "total-label" }, "Total", -1))
const _hoisted_12 = { class: "prix" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.panier.poisson)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t('boite.poisson')) + " ", 1),
            _hoisted_5
          ]))
        : _createCommentVNode("", true),
      (_ctx.panier.gibier)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.$t('boite.gibier')) + " ", 1),
            _hoisted_7
          ]))
        : _createCommentVNode("", true),
      (_ctx.panier.saumon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.$t('boite.saumon')) + " ", 1),
            _hoisted_9
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", null, [
        _hoisted_11,
        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.total), 1)
      ])
    ])
  ]))
}